var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenDesktopComputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4374",
    "data-name": "Group 4374",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.863,
    height: 30.916,
    viewBox: "0 0 33.863 30.916",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3519",
    "data-name": "Rectangle 3519",
    width: 33.864,
    height: 30.916,
    transform: "translate(0 0)",
    fill: "#6b9672"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4339",
    "data-name": "Group 4339",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    "data-name": "Path 3864",
    d: "M32.614,0H1.213A1.218,1.218,0,0,0,0,1.218V25.094a1.218,1.218,0,0,0,1.213,1.218H12.125V28.2h-1.64a1.36,1.36,0,0,0,0,2.719H23.379a1.36,1.36,0,1,0,0-2.719h-1.6V26.312H32.652a1.218,1.218,0,0,0,1.212-1.218V1.256A1.252,1.252,0,0,0,32.614,0M15.638,23.9a1.294,1.294,0,1,1,1.294,1.283A1.3,1.3,0,0,1,15.638,23.9m15.769-2.79H2.458V2.447H31.407Z",
    fill: "#6b9672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    d: "M6.5,17.718h4.458a1.3,1.3,0,0,0,1.3-1.3V8.151a1.3,1.3,0,0,0-1.3-1.3H6.5a1.3,1.3,0,0,0-1.3,1.3v8.27a1.3,1.3,0,0,0,1.3,1.3",
    fill: "#6b9672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    d: "M15.649,8.977H27.66a1.061,1.061,0,1,0,0-2.122H15.649a1.061,1.061,0,0,0,0,2.122",
    fill: "#6b9672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    "data-name": "Path 3867",
    d: "M15.649,13.347H27.66a1.061,1.061,0,1,0,0-2.122H15.649a1.061,1.061,0,1,0,0,2.122",
    fill: "#6b9672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    d: "M15.649,17.718H27.66a1.061,1.061,0,1,0,0-2.122H15.649a1.061,1.061,0,0,0,0,2.122",
    fill: "#6b9672"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenDesktopComputer);
export default __webpack_public_path__ + "static/media/greenDesktopComputer.4db37766.svg";
export { ForwardRef as ReactComponent };